import { reviews } from "@/mocks/chigua";

const principles = [
  { icon: "ri-eye-line", title: "客观中立", text: "只做入口与方向整理，不站队、不预设立场，把判断权留给你。" },
  { icon: "ri-user-heart-line", title: "尊重隐私", text: "关注公共议题与公开讨论，对私人信息保持克制，绝不引导网络暴力。" },
  { icon: "ri-feedback-line", title: "拒绝谣言", text: "鼓励多方交叉核对，未经证实的信息谨慎对待，让谣言没有土壤。" },
  { icon: "ri-copyright-line", title: "尊重版权", text: "引导访问各平台官方页面，转载与二创遵守平台规则与作者意愿。" },
];

const stats = [
  { num: "30+", label: "覆盖讨论入口方向" },
  { num: "8+", label: "主流平台直达" },
  { num: "24h", label: "入口持续更新维护" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold tracking-wide text-primary-800">
              <i className="ri-hand-heart-line" aria-hidden="true"></i>
              关于我们
            </p>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              把热闹看清楚，把入口给你
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">
              吃瓜路线诞生于一个很朴素的困扰：热点层出不穷，可常去的讨论入口散落在不同的平台和收藏夹里，
              每次想围观都要来回折腾。所以我们干脆把这些官方入口和讨论方向集中起来，做成一个清爽的导航站，
              让你想围观时打开一个页面就能出发。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              我们相信，围观热闹不只是一时的情绪，更是一群人对公共话题的关注与讨论。
              因此我们始终坚持做“方便的工具”，同时强调理性与克制——只整理入口与方向，
              鼓励交叉核对、尊重当事人，让每一次围观都既尽兴又不越界。
            </p>

            <div className="mt-7 grid grid-cols-3 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-background-200/80 bg-background-100 p-4 text-center">
                  <div className="font-heading text-2xl font-black text-accent-600">{s.num}</div>
                  <div className="mt-1 text-xs leading-snug text-foreground-600">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950">我们的内容原则</h3>
            <div className="mt-5 space-y-3">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-4 rounded-2xl border border-background-200/80 bg-background-100 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-900">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h4 className="font-semibold text-foreground-950">{p.title}</h4>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-3xl border border-accent-200/70 bg-background-100 p-6 md:p-8">
          <div className="flex flex-col items-start gap-1 md:flex-row md:items-end md:justify-between">
            <div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">围观群众的心里话</h3>
              <p className="mt-1 text-sm text-foreground-600">来自不同兴趣圈子里常驻用户的使用反馈。</p>
            </div>
            <div className="flex items-center gap-1 text-accent-500" aria-label="五星好评">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-lg" aria-hidden="true"></i>
              ))}
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {reviews.map((r) => (
              <figure key={r.name} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5">
                <i className="ri-double-quotes-l text-2xl text-primary-400" aria-hidden="true"></i>
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{r.name}</div>
                    <div className="text-xs text-foreground-500">{r.role}</div>
                  </div>
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">{r.tag}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}